/**
 * Returns true if the card is a double-faced card (transform or modal_dfc layout
 * with at least two card faces).
 */
export function isDoubleFaced(card) {
    return (card.layout === 'transform' || card.layout === 'modal_dfc') &&
        (card.cardFaces?.length ?? 0) >= 2;
}
/**
 * Returns the primary image URI for a card, handling multi-face cards.
 * Fallback chain: imageUris[size] → cardFaces[faceIndex].imageUris[size] → normal fallbacks.
 * @param card - The card to get the image URI for.
 * @param size - The image size to retrieve (default: 'normal').
 * @param faceIndex - For DFC cards, which face to show (default: 0).
 */
export function getCardImageUri(card, size = 'normal', faceIndex = 0) {
    if (card.imageUris?.[size])
        return card.imageUris[size]; // non-DFC: always top-level
    const face = card.cardFaces?.[faceIndex] ?? card.cardFaces?.[0];
    if (face?.imageUris?.[size])
        return face.imageUris[size];
    // fallback to normal if size not found
    if (card.imageUris?.normal)
        return card.imageUris.normal;
    if (face?.imageUris?.normal)
        return face.imageUris.normal;
    return undefined;
}
export function getCardTypeLine(card) {
    if (card.typeLine)
        return card.typeLine;
    return card.cardFaces?.[0]?.typeLine ?? '';
}
export function getCardManaCost(card) {
    let cost = card.manaCost || card.cardFaces?.[0]?.manaCost || '';
    // For split/adventure cards, only show the main (first) face cost
    if (cost.includes(' // '))
        cost = cost.split(' // ')[0];
    return cost;
}
export function getCardArtist(card) {
    if (card.artist)
        return card.artist;
    return card.cardFaces?.[0]?.artist ?? '';
}
//# sourceMappingURL=card.js.map